module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/powered-by-google-f28a13545ca7be5cd9ea31bdd9ea7f8e.png";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/powered-by-google.png
// module id = 1253
// module chunks = 0